import React from 'react';
import { SpaceType } from './SpaceAssignments';

export const SiteIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 12.5 12.5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'inline-block', verticalAlign: 'middle' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.5 0H12C12.2766 0 12.5 0.223437 12.5 0.5V12C12.5 12.2766 12.2766 12.5 12 12.5H0.5C0.223437 12.5 0 12.2766 0 12V0.5C0 0.223437 0.223437 0 0.5 0ZM9.41667 11.375H11.375V4.75H4.75L4.75 8.08333H8.91667C9.19281 8.08333 9.41667 8.30719 9.41667 8.58333V11.375ZM8.41667 11.375H1.125V1.125H11.375V3.75H4.25C3.97386 3.75 3.75 3.97386 3.75 4.25L3.75 8.58333C3.75 8.71594 3.80268 8.84312 3.89645 8.93689C3.99021 9.03066 4.11739 9.08333 4.25 9.08333H8.41667V11.375Z"
      fill="currentColor"
      fillOpacity="0.88"
    />
  </svg>
);

export const BuildingIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 11 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'inline-block', verticalAlign: 'middle' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 0.633334C0 0.283558 0.283549 0 0.633333 0H10.3667C10.7164 0 11 0.283554 11 0.633333V13.3667C11 13.7164 10.7165 14 10.3667 14H0.633333C0.283552 14 0 13.7164 0 13.3667V0.633334ZM1 1V13H2.83333V10.6333C2.83333 10.2836 3.11689 10 3.46667 10H7.53333C7.88311 10 8.16667 10.2836 8.16667 10.6333V13H10V1H1ZM7.16667 13H3.83333V11H7.16667V13ZM5 3.36667C5 3.4403 4.9403 3.5 4.86667 3.5H2.46667C2.39303 3.5 2.33333 3.4403 2.33333 3.36667V2.63333C2.33333 2.5597 2.39303 2.5 2.46667 2.5H4.86667C4.9403 2.5 5 2.5597 5 2.63333V3.36667ZM5 5.7C5 5.77364 4.9403 5.83333 4.86667 5.83333H2.46667C2.39303 5.83333 2.33333 5.77364 2.33333 5.7V4.96667C2.33333 4.89303 2.39303 4.83333 2.46667 4.83333H4.86667C4.9403 4.83333 5 4.89303 5 4.96667V5.7ZM4.86667 8.16667C4.9403 8.16667 5 8.10697 5 8.03333V7.3C5 7.22636 4.9403 7.16667 4.86667 7.16667H2.46667C2.39303 7.16667 2.33333 7.22636 2.33333 7.3V8.03333C2.33333 8.10697 2.39303 8.16667 2.46667 8.16667H4.86667ZM8.66667 3.36667C8.66667 3.4403 8.60697 3.5 8.53333 3.5H6.13333C6.0597 3.5 6 3.4403 6 3.36667V2.63333C6 2.5597 6.0597 2.5 6.13333 2.5H8.53333C8.60697 2.5 8.66667 2.5597 8.66667 2.63333V3.36667ZM8.53333 5.83333C8.60697 5.83333 8.66667 5.77364 8.66667 5.7V4.96667C8.66667 4.89303 8.60697 4.83333 8.53333 4.83333H6.13333C6.0597 4.83333 6 4.89303 6 4.96667V5.7C6 5.77364 6.0597 5.83333 6.13333 5.83333H8.53333ZM8.66667 8.03333C8.66667 8.10697 8.60697 8.16667 8.53333 8.16667H6.13333C6.0597 8.16667 6 8.10697 6 8.03333V7.3C6 7.22636 6.0597 7.16667 6.13333 7.16667H8.53333C8.60697 7.16667 8.66667 7.22636 8.66667 7.3V8.03333Z"
      fill="currentColor"
      fillOpacity="0.88"
    />
  </svg>
);

export const FloorIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 12.7322 13.8678"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'inline-block', verticalAlign: 'middle' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.317331 3.38503C-0.105779 3.62863 -0.105776 4.23916 0.317332 4.48276L1.96936 5.43389L0.31734 6.38502C-0.10577 6.62862 -0.105767 7.23915 0.317341 7.48275L1.96937 8.43388L0.31734 9.38502C-0.10577 9.62862 -0.105767 10.2392 0.317341 10.4827L6.05011 13.7833C6.24573 13.8959 6.4865 13.8959 6.68212 13.7833L12.4149 10.4827C12.838 10.2391 12.838 9.62862 12.4149 9.38502L10.7629 8.43388L12.4149 7.48275C12.838 7.23915 12.838 6.62862 12.4149 6.38502L10.7629 5.43389L12.4149 4.48276C12.838 4.23916 12.838 3.62863 12.4149 3.38503L6.68211 0.0844673C6.48649 -0.0281564 6.24572 -0.0281551 6.0501 0.0844673L0.317331 3.38503ZM9.76076 6.01083L6.68211 7.78333C6.48649 7.89595 6.24572 7.89595 6.0501 7.78333L2.97146 6.01084L1.36822 6.93388L6.36612 9.81135L11.364 6.93388L9.76076 6.01083ZM6.36611 6.81137L1.36821 3.9339L6.36611 1.05643L11.364 3.9339L6.36611 6.81137ZM1.36822 9.93388L2.97148 9.01083L6.05011 10.7833C6.24573 10.8959 6.4865 10.8959 6.68212 10.7833L9.76075 9.01083L11.364 9.93388L6.36612 12.8114L1.36822 9.93388Z"
      fill="currentColor"
      fillOpacity="0.88"
    />
  </svg>
);

export const RoomIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'inline-block', verticalAlign: 'middle' }}
  >
    <rect
      x="2"
      y="4"
      width="12"
      height="8"
      rx="1"
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
    />
  </svg>
);

export const getSpaceLevelIcon = (level: SpaceType): React.ReactNode => {
  switch (level) {
    case 'site':
      return <SiteIcon />;
    case 'building':
      return <BuildingIcon />;
    case 'floor':
      return <FloorIcon />;
    case 'room':
      return <RoomIcon />;
    case 'zone':
      return <RoomIcon />;
    default:
      return <RoomIcon />;
  }
};
